import { Box, Grid, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { LEFT_RAIL_WIDTH, useBrandVersion } from 'common';

export function PageWithCustomLefNav({ leftNavContent, children }: { leftNavContent: ReactNode; children: ReactNode }) {
    const isNewBrand = useBrandVersion() === 'newBrand';

    return (
        <Box height="100%">
            <Grid container width="100%" height="100%" alignContent="flex-start">
                <Grid
                    item
                    xs={12}
                    lg={isNewBrand ? undefined : 2}
                    sx={(t) => ({
                        p: 2,
                        minWidth: 0,
                        [t.breakpoints.down('lg')]: {
                            pb: 0,
                        },
                        [t.breakpoints.up('lg')]: {
                            height: '100%',
                            backgroundColor: t.palette.background.paper,
                            boxShadow: t.shadows[2],
                            ...(isNewBrand && { width: LEFT_RAIL_WIDTH, flexBasis: LEFT_RAIL_WIDTH, flexGrow: 0 }),
                        },
                    })}
                >
                    {leftNavContent}
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={isNewBrand ? undefined : 10}
                    maxHeight="100%"
                    sx={(t) => ({
                        minWidth: 0,
                        [t.breakpoints.up('lg')]: {
                            ...(isNewBrand && { flexGrow: 1, flexBasis: 0 }),
                        },
                    })}
                >
                    <Stack
                        sx={(t) => ({
                            alignItems: 'center',
                            width: '100%',
                            p: 2,
                            [t.breakpoints.up('lg')]: { overflowY: 'auto', maxHeight: '100%', height: '100%' },
                        })}
                    >
                        {children}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
